export const AGES_PER_GAME = 3;
export const TURNS_PER_AGE = 5;

export const MAX_MILITARY = 25;
export const MAX_GOLD = 25;

export const FAVOR_PER_TRIBUTE_TOKEN = 3;

// Standard per-age caps (10/15/20)
export const MAX_MILITARY_PER_AGE = [10, 15, 20];
export const MAX_GOLD_PER_AGE = [10, 15, 20];

// LowMil: gold 10/15/20, military 5/10/15
export const MAX_MILITARY_LOW_MIL_PER_AGE = [5, 10, 15];

// Bump: 12/16/20 for both
export const MAX_BUMP_PER_AGE = [12, 16, 20];

export const MERCENARY_CARD_DEF_IDS = new Set<string>([
  'mercenary_1_1',
  'mercenary_1_2',
  'mercenary_1_3',
  'mercenary_1_4',
  'mercenary_2_1',
  'mercenary_2_2',
  'mercenary_2_3',
  'mercenary_2_4',
  'mercenary_3_1',
  'mercenary_3_2',
  'mercenary_3_3',
  'mercenary_3_4',
]);

export const SCAVENGE_CARD_DEF_IDS = new Set<string>([
  'scavenge_i',
  'scavenge_ii',
  'scavenge_iii',
]);

export const SETTLEMENT_CARD_DEF_IDS = new Set<string>([
  'settlement_i',
  'settlement_ii',
  'settlement_iii',
]);
